import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {Note} from "../model/note";

@Component({
    selector: 'response-dialog',
    templateUrl: './responseDialog.component.html',
    styleUrls: ['./responseDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ResponseDialogComponent {
    action: string;
    noteForm: FormGroup;
    dialogTitle: string;
    note: Note;

    constructor(
        public matDialogRef: MatDialogRef<ResponseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.note = _data.note;

        this.noteForm = this.createForm();
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            title: ['Re: ' + this.note.title, Validators.required],
            parent: [this.note.id, Validators.required],
            description: ['', Validators.required],
        });
    }
}
